import PaginationArrowLeftIcon from "../icons/pagination-arrow-left.icon";
import PaginationArrowRightIcon from "../icons/pagination-arrow-right.icon";

const ArrowButton = ({ toRight = false, isDisabled = false, onClick = () => { } }) => (
  <div className="arrow-button" onClick={() => { if (!isDisabled) onClick(); }}>
    {toRight ? <PaginationArrowRightIcon fill={isDisabled ? '#BBBEC9' : '#616778'} /> : <PaginationArrowLeftIcon fill={isDisabled ? '#BBBEC9' : '#616778'} />}
  </div>
)
export default ArrowButton;